import type { ReactNode } from "react";
import { type QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SessionProvider } from "./session";

/** What wraps the router, in the browser and when prerendering alike (the two must draw the same tree). */
export function AppProviders({ queryClient, children }: { queryClient: QueryClient; children: ReactNode }) {
    return (
        <QueryClientProvider client={queryClient}>
            <SessionProvider>
                {children}
            </SessionProvider>
        </QueryClientProvider>
    );
}
